export default "/assets/website/images/2006.jpg?c40bf4ed335fd5676105d36a013e21dc";